import { useQuery } from '@tanstack/react-query'

import { fetchCampaignSummary } from '@/lib/venue/campaignApi'

export function campaignSummaryQueryKey(
  venueId: string,
  params: { from: string; to: string; type?: 'NOTICE' | 'PROMOTION' }
) {
  return ['venue', venueId, 'campaign-summary', params] as const
}

/** 관리 홈 요약 카드(#728 §3) — `type`별로 각각 호출한다(운영공지·지역홍보 카드가 별개 쿼리). */
export function useCampaignSummary(venueId: string, params: { from: string; to: string; type?: 'NOTICE' | 'PROMOTION' }) {
  return useQuery({
    queryKey: campaignSummaryQueryKey(venueId, params),
    queryFn: () => fetchCampaignSummary(venueId, params),
  })
}
